export default __webpack_public_path__ + "static/rancher-63417e8369848e4be5307f2db23180fe.jpeg";